import { deleteFillInTheBlankQuestionIntoActivity } from '@/data/services/question/fillInTheBlankQuestionServices';
import { deleteOrderingQuestionIntoActivity } from '@/data/services/question/orderingQuestionServices';
import { deletePositionalQuestionIntoActivity } from '@/data/services/question/positionalQuestionServices';
import { deleteQuizQuestionIntoActivity } from '@/data/services/question/quizQuestionServices';
import { deleteTextQuestionIntoActivity } from '@/data/services/question/textQuestionServices';
import { deleteTrueOrFalseQuestionIntoActivity } from '@/data/services/question/trueOrFalseQuestionServices';
import { deleteWritingQuestionIntoActivity } from '@/data/services/question/writingQuestionServices';
import { deleteFlashcardQuestionIntoActivity } from '@/data/services/question/flashcardQuestionServices';
import { QuestionTypeEnum } from '@/models/Question';

type DeleteQuestionParams = {
  activityId: number;
  id: number;
  type: QuestionTypeEnum;
};

const services: Partial<
  Record<QuestionTypeEnum, (activityId: number, id: number) => Promise<void>>
> = {
  [QuestionTypeEnum.TEXT]: deleteTextQuestionIntoActivity,
  [QuestionTypeEnum.QUIZ]: deleteQuizQuestionIntoActivity,
  [QuestionTypeEnum.TRUE_OR_FALSE]: deleteTrueOrFalseQuestionIntoActivity,
  [QuestionTypeEnum.WRITING]: deleteWritingQuestionIntoActivity,
  [QuestionTypeEnum.DND_ORDENATION]: deleteOrderingQuestionIntoActivity,
  [QuestionTypeEnum.DND_POSITIONAL]: deletePositionalQuestionIntoActivity,
  [QuestionTypeEnum.FILL_IN_THE_BLANK]:
    deleteFillInTheBlankQuestionIntoActivity,
  [QuestionTypeEnum.FLASHCARD]: deleteFlashcardQuestionIntoActivity,
};

const deleteQuestion = async ({
  activityId,
  id,
  type,
}: DeleteQuestionParams) => {
  const service = services[type];
  if (!service) throw new Error(`Unsupported question type: ${type}`);
  return service(activityId, id);
};

export default deleteQuestion;
